// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

// コンポーネントのインポート
import Footer from './components/Footer';
import Hero from './sections/Hero';
import Service from './sections/Service';
import Store from './sections/Store';
import Company from './sections/Company';
import Press from './sections/Press';
import Links from './sections/Links';
import Partner from './sections/Partner';
import Missionmv from './sections/Missionmv';



import './styles/index.css';

function App() {  
  return (
    <Router>
      <div className="app-container">
        <main className="main-content">
          <Hero />
          <Missionmv />
          <Service />
          <Store />
          <Company />
          <Press />
          <Links />
          <Partner />
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;